import { defineMessages } from 'react-intl';

export const registrationInvitationErrorMessages = defineMessages({
    invitationExpiredTitle: {
        id: 'registration.invitation_expired_error_title',
        defaultMessage: 'Your Friends and Family invite link has expired.',
        description:
            'Title of the error when an invitation is expired or invalid',
    },
    invitationRedeemedTitle: {
        id: 'registration.invitation_redeemed_error_title',
        defaultMessage:
            'This Friends and Family invite link has been redeemed already.',
        description: 'Title of the error when an invitation has been redeemed',
    },
    subtitle: {
        id: 'registration.invitation_error_subtitle',
        defaultMessage: 'Please ask your sponsor to invite you again.',
        description: 'Subtitle of the invitation error dialog',
    },
});
